import "./Section.scss";
export default function SectionClone(props) {
  return (
    <div
      className={`section-line-container editable`}
    >
      <div className="section-label">
        <span>Začiatok sekcie</span>
        <span className="section-delete">&times;</span>
      </div>
      {(props.section.lines === "up" || props.section.lines === "both")
        &&
        <div className="section-line">
        </div>
      }
      <div className="section-title">
        {props.section.title}
      </div>
      {(props.section.lines === "down" || props.section.lines === "both")
        &&
        <div className="section-line">
        </div>
      }
    </div>
  );
}
